import classNames from 'classnames';
import { parseISO } from 'date-fns';
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import DatesRange from './DatesRange';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/draws-winners.module.scss';

const propTypes = {
    title: PropTypes.node,
    draws: PropTypes.arrayOf(
        PropTypes.shape({
            names: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    draws: null,
    className: null,
};

function DrawsWinners({ title, draws, className }) {
    const themeClassName = useThemeClassName(styles);

    const items = useMemo(
        () =>
            sortBy(
                draws.reduce((allWinners, draw) => {
                    const { batches: drawBatches = null } = draw || {};
                    return (drawBatches || []).reduce((batchWinners, drawBatch) => {
                        const {
                            startAt = null,
                            endAt = null,
                            winnersCount: count = 0,
                            winners: names = null,
                        } = drawBatch || {};
                        return count > 0 || (names !== null && names.length > 0)
                            ? [
                                  ...batchWinners,
                                  {
                                      names,
                                      count,
                                      startAt,
                                      endAt,
                                  },
                              ]
                            : batchWinners;
                    }, allWinners);
                }, []),
                ({ startAt }) => parseISO(startAt).getTime(),
            ).reverse(),
        [draws],
    );
    if (items.length <= 0) {
        return null;
    }
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.title}>
                {title || (
                    <FormattedMessage
                        defaultMessage="And the winners are"
                        description="Winners list title"
                    />
                )}
            </div>
            <div className={styles.items}>
                {items.map(({ startAt, endAt, count, names }, winnerIndex) => (
                    <div key={`winner-${winnerIndex + 1}`} className={styles.item}>
                        <div className={styles.content}>
                            <div className={styles.date}>
                                <DatesRange startAt={startAt} endAt={endAt} />
                            </div>
                            <div className={styles.label}>
                                {count > names.length ? (
                                    <FormattedMessage
                                        defaultMessage="{names} and {count} more..."
                                        description="Winners count"
                                        values={{
                                            names: (
                                                <div className={styles.names}>
                                                    {names.join(' , ')}
                                                </div>
                                            ),
                                            count: count - names.length,
                                        }}
                                    />
                                ) : (
                                    <span className={styles.names}>{names.join(' , ')}</span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

DrawsWinners.propTypes = propTypes;
DrawsWinners.defaultProps = defaultProps;

export default DrawsWinners;
